import {z} from 'zod';

export const salePresetFormSchema = z.object({
  name: z.string().trim().min(1).max(255),
  makes: z.array(z.string()),
  watermarkId: z.string().nullable(),
  backgroundRemovalId: z.string().nullable(),
  digitalCertificateThemeId: z.string().nullable(),
  warrantyProgramId: z.string().nullable(),
  defaultQualitySealKey: z.string().nullable(),
});

export type SalePresetFormValues = z.infer<typeof salePresetFormSchema>;
